import { AuthPhoneForm } from 'feature/auth/AuthPhoneForm'
import { doLogin } from 'feature/auth/redux/action/doLogin'
import { getAuthSms } from 'feature/auth/redux/action/getAuthSms'
import { AuthStatus, SmsStatus } from 'feature/auth/redux/authSlice'
import { useSendForm } from 'feature/productOrder/hooks/useSendForm'
import { phones } from 'helpers/phones'
import { MainLayout } from 'layouts'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Loading } from 'router/Loading'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { SmsCodeConfirm } from 'widget'

export function Login() {
  const navigate = useNavigate()
  const thunkDispatch = useThunkDispatch()
  const [isLoading, setLoading] = useState<boolean>(false)
  const [orderLoading, setOrderLoading] = useState<boolean>(false)

  const { clearMap, clearAddress } = useActions()

  const { sendForm } = useSendForm()
  const location = useLocation()

  const { authInfo, userInfo, smsInfo } = useAppSelector(state => state.auth)

  const { setSmsInfo } = useActions()

  useEffect(() => {
    switch (authInfo.status) {
      case AuthStatus.registered:
        setSmsInfo({ status: SmsStatus.readyForSend })
        if (location?.state?.sendingForm) {
          setOrderLoading(true)
          sendForm({ forceNavigate: false })
          return
        }
        navigate('/')
        break
      case AuthStatus.smsConfirmed:
        setSmsInfo({ status: SmsStatus.readyForSend })
        navigate('/registration', {
          state: { sendingForm: !!location?.state?.sendingForm || false },
        })
        break
    }
  }, [authInfo.status])

  useEffect(() => {
    if (authInfo.status === AuthStatus.guest) {
      setSmsInfo({ status: SmsStatus.readyForSend, blockTime: 0 })
      clearMap()
      clearAddress()
    }
  }, [])

  const handlerGetSms = () => {
    thunkDispatch(getAuthSms(userInfo.phone))
  }

  const handlerLogin = async (code: string, phoneNumber: string) => {
    setLoading(true)
    thunkDispatch(
      doLogin({
        phone: `+${phones(phoneNumber)}`,
        code,
        agree: true,
      }),
    ).finally(() => setLoading(false))
  }

  const smsChangeHandler = () => {
    setSmsInfo({ error: null })
  }

  const smsBackHandler = () => {
    setSmsInfo({ status: SmsStatus.readyForSend })
  }

  if (orderLoading)
    return (
      <MainLayout>
        <Loading />
      </MainLayout>
    )

  return (
    <MainLayout>
      <div className='container'>
        {smsInfo.status === SmsStatus.readyForSend && <AuthPhoneForm />}
        {smsInfo.status === SmsStatus.sendedCode && (
          <SmsCodeConfirm
            title='Вход или регистрация'
            startTimerPosition={smsInfo.blockTime}
            backHandler={smsBackHandler}
            phone={userInfo.phone}
            onReRequestSms={handlerGetSms}
            onCodeSubmit={handlerLogin}
            errorText={smsInfo.error}
            onChange={smsChangeHandler}
            isButtonLoading={isLoading}
            needAgree={userInfo.isDataAgreeRequired}
          />
        )}
      </div>
    </MainLayout>
  )
}
